// @ts-nocheck
import React from 'react';

// STYLES
import 'Assets/styles/default/components/HeaderMenu/HeaderMenuStyles.less';
import MenuItemsDesktop from 'components/Menu/MenuItemsDesktop';

const HeaderMenuDefault = () => {
  return (
    <div className="header-menu-content">
      <MenuItemsDesktop menuType="categoryMenu" />
    </div>
  );
};

export default HeaderMenuDefault;
